<template>
  <router-view />
</template>

<script>
export default {
  name: 'ClientsIndex'
}
</script>
